module.exports = __webpack_public_path__ + "img/preview-lg.367cb671.png";